import lodash from "lodash";
import Vue from "vue";
/** PagesEnum 自动生成请勿修改  */
/** @InjectPages **/
export const PagesEnum = {
    /** pages/example/index  */
    Example: { name: 'example' },
    /** pages/index  */
    Index: { name: 'index' },
    /** pages/protocol/list/index  */
    Protocol_list: { name: 'protocol-list' },
    /** pages/protocol/userLog/index  */
    Protocol_user_log: { name: 'protocol-userLog' }
};
/** @InjectPages **/
lodash.set(Vue, '$Pages', PagesEnum);
Object.defineProperty(Vue.prototype, "$Pages", {
    get: lodash.constant(PagesEnum),
});
